export const getRemoteJson = async (url: string) => {
  try {
    const response = await fetch(url);
    if (response && response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.log(error);
  }
};
